import tailwindConstants from '@/utils/tailwind.constants'

const COLOR_CLASSES = tailwindConstants.COLOR_CLASSES

const LABELS = {
  fullyAutomated: {
    label: 'Fully automated',
    color: COLOR_CLASSES.SUCCESS,
    tooltip: 'The virtual assistant understood the customer\'s intent, and then provided an answer which successfully resolved the customer\'s query.'
  },
  partiallyAutomated: {
    label: 'Partially automated',
    color: COLOR_CLASSES.WARNING,
    tooltip: 'The virtual assistant understood the customer\'s intent, and then provided an answer which partially resolved the customer\'s query.<br/><br/>Improving the answer (providing all options, answering edge cases, etc.) could recategorize these outcomes as <strong>Fully automated</strong> and improve the respective rate.'
  },
  wrongAnswer: {
    label: 'Wrong answer',
    color: COLOR_CLASSES.FOCUS_ERROR,
    tooltip: '<strong>EITHER</strong> the virtual assistant misunderstood the customer\'s intent and provided an incorrect answer <strong>OR</strong> the answer provided did not satisfy the customer.'
  },
  notAutomated: {
    label: 'Not automated',
    color: COLOR_CLASSES.GRAY,
    tooltip: '<strong>EITHER</strong> the virtual assistant failed to understand the customer\'s intent <strong>OR</strong> an answer was not created for the intent.'
  },
  requestedOperator: {
    label: 'Requested operator',
    color: COLOR_CLASSES.GRAY_DARK,
    tooltip: 'The customer requested to <strong>Call Operator.</strong>'
  },
  servedByBot: {
    label: 'Served by bot',
    color: COLOR_CLASSES.SUCCESS,
    tooltip: 'Every single <b>request</b> of this <b>contact</b> was resolved correctly by the bot.'
  },
  servedByOperator: {
    label: 'Served by operator',
    color: COLOR_CLASSES.WARNING,
    tooltip: 'A customer asked for the help of an operator AND the operator actually came.'
  },
  agentOffline: {
    label: 'Operator not reachable (offline)',
    color: COLOR_CLASSES.FOCUS_ERROR,
    tooltip: 'Customer asked for the help of an operator BUT the operators were offline.'
  },
  conversationTimeout: {
    label: 'Operator not reachable (timeout)',
    color: COLOR_CLASSES.GRAY,
    tooltip: 'Customer asked for the help of an operator. The operators were online BUT the chat timed out before an operator server the customer.'
  }
}

export default LABELS
